import React from 'react';
import { styles } from './styles';

const LoadingState = () => {
  return (
    <div style={styles.loadingContainer}>
      <div style={styles.spinner}></div>
      <p style={styles.loadingText}>Loading...</p>
    </div>
  );
};

export default LoadingState;